<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-50 md-size-50">
            <h4>{{translate(locale.systemClients)}}</h4>
        </div>
        <div class="md-layout-item md-medium-size-100 md-size-100">
            <md-card>
                <md-card-content>
                    <loading v-if="!loaded" />
                    <div v-if="loaded">
                        <div class="md-layout">
                            <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100"
                                style="display: flex; align-items: center;">
                                <h4 class="order-title">
                                    <b>{{client.name}}</b>
                                </h4>
                            </div>
                            <div
                                class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-40">
                                <md-field>
                                    <label>{{translate(locale.searchLog)}}</label>
                                    <md-input v-model="filter.text" type="text" @keyup.enter="searchLog()"></md-input>
                                </md-field>
                            </div>
                            <div
                                class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-20">
                                <md-field>
                                    <label>{{translate(locale.channelCode)}} *</label>
                                    <md-select :placeholder="translate(locale.channelCodeAll)" v-model="filter.channel">
                                        <md-option value="">{{translate(locale.all)}}</md-option>
                                        <md-option v-for="channel in channelList"
                                            :value="channel.slug">{{channel.name}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div
                                class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-20">
                                <md-field>
                                    <label>{{translate(locale.refreshRate)}}</label>
                                    <md-select :placeholder="translate(locale.refreshRate)" v-model="filter.refresh">
                                        <md-option value="5">5 {{translate(locale.second)}}</md-option>
                                        <md-option value="10">10 {{translate(locale.second)}}</md-option>
                                        <md-option value="30">30 {{translate(locale.second)}}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div
                                class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-20">
                                <md-button class="md-raised md-primary" @click="searchLog()"
                                    style="width: 100%">{{translate(locale.update)}}</md-button>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
                                <md-table>
                                    <md-table-row>
                                        <md-table-head style="width: 40px"></md-table-head>
                                        <md-table-head
                                            style="min-width: 280px">{{translate(locale.logInfo)}}</md-table-head>
                                        <md-table-head
                                            style="width: 100%;">{{translate(locale.description)}}</md-table-head>
                                    </md-table-row>
                                    <md-table-row v-for="(log, index) in logList">
                                        <md-table-cell>{{index+1}}</md-table-cell>
                                        <md-table-cell>
                                            <span>
                                                <span v-if="log.level_id == 1"><span style="color:green; font-size: 20px;">&#10687; </span>{{translate(locale.sendNotificationNormalLog)}}<br></span>
                                                <span v-if="log.level_id == 2"><span style="color:orange; font-size: 20px;">&#10687; </span>{{translate(locale.sendNotificationWarningLog)}}<br></span>
                                                <span v-if="log.level_id == 3"><span style="color:red; font-size: 20px;">&#10687; </span>{{translate(locale.sendNotificationCriticalLog)}}<br></span>
                                            </span>
                                            <br>
                                            <span>{{log.hash}} ({{log.slug}})</span>
                                            <br>
                                            <span>{{translate(config.datelify(log.created_date))}} ({{translate(config.getAge(log.created_date))}})</span>
                                        </md-table-cell>
                                        <md-table-cell>{{log.text}}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                                <h5 class="text-center" v-if="logList.length == 0 && loaded == true">
                                    {{translate(locale.noLog)}}</h5>
                                <div class="places-buttons text-center" v-if="loadMore">
                                    <md-button class="md-primary"
                                        @click="searchLog(true)">{{translate(locale.showMore)}}</md-button>
                                </div>
                            </div>

                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        created() {
            this.getClient();
            this.searchLog();

            this.setAuto();
        },
        beforeDestroy() {
            clearInterval(this.interval);
        },
        data() {
            return {
                loaded: false,
                loadMore: false,
                client: {
                    hash: "",
                    name: "",
                    api_key: "",
                    user_name: "",
                    user_role: "",
                    created_date: "",
                    updated_date: "",
                    status: ""
                },
                interval: null,
                logList: [],
                channelList: [],
                filter: {
                    channel: "",
                    refresh: "10",
                    text: ""
                }
            }
        },
        methods: {
            setAuto() {
                clearInterval(this.interval);
                this.interval = setInterval(() => {
                    this.searchLog();
                }, parseInt(this.filter.refresh) * 1000);
            },
            getClient() {
                this.$http.get(this.config.api + "/admin/log/get/" + this.$route.params.hash).then(data => {
                    this.client = data.body.data.client;
                    this.channelList = data.body.data.channel;

                    this.loaded = true;
                })
            },
            searchLog(more = false) {
                this.$http.post(this.config.api + "/admin/log/search_log", {
                    hash: this.$route.params.hash,
                    text: this.filter.text,
                    channel: this.filter.channel,
                    offset: more ? this.logList.length : 0
                }).then(data => {
                    this.loaded = true;
                    if (data.body.data.length == 100) this.loadMore = true;
                    else this.loadMore = false;
                    this.logList = more ? this.logList.concat(data.body.data) : data.body.data;
                    this.setAuto();
                })
            },
            onCancel() {
                this.revokeDialogActive = false;
            }
        }
    }
</script>
<style scoped>
    .product-thumbnail {
        width: 64px;
        height: 64px;
    }

    .grid-8 {
        text-align: center;
        max-width: 20%;
        min-width: 20%;
        flex: 0 0 20%;
    }

    .thumb-product {
        width: 50%;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Log/Detail.vue